var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var FIFO = require('fast-fifo');

module.exports = function (options) {
  var _pushable2, _pushable3;

  options = options || {};
  var onEnd;

  if (typeof options === 'function') {
    onEnd = options;
    options = {};
  } else {
    onEnd = options.onEnd;
  }

  var buffer = new FIFO();

  var pushable, _onNext, ended;

  var waitNext = function waitNext() {
    if (!buffer.isEmpty()) {
      if (options.writev) {
        var _next;

        var values = [];

        while (!buffer.isEmpty()) {
          _next = buffer.shift();
          if (_next.error) throw _next.error;
          values.push(_next.value);
        }

        return {
          done: _next.done,
          value: values
        };
      }

      var next = buffer.shift();
      if (next.error) throw next.error;
      return next;
    }

    if (ended) return {
      done: true
    };
    return new Promise(function (resolve, reject) {
      _onNext = function onNext(next) {
        _onNext = null;

        if (next.error) {
          reject(next.error);
        } else {
          if (options.writev && !next.done) {
            resolve({
              done: next.done,
              value: [next.value]
            });
          } else {
            resolve(next);
          }
        }

        return pushable;
      };
    });
  };

  var bufferNext = function bufferNext(next) {
    if (_onNext) return _onNext(next);
    buffer.push(next);
    return pushable;
  };

  var bufferError = function bufferError(err) {
    buffer = new FIFO();
    if (_onNext) return _onNext({
      error: err
    });
    buffer.push({
      error: err
    });
    return pushable;
  };

  var push = function push(value) {
    if (ended) return pushable;
    return bufferNext({
      done: false,
      value: value
    });
  };

  var end = function end(err) {
    if (ended) return pushable;
    ended = true;
    return err ? bufferError(err) : bufferNext({
      done: true
    });
  };

  var _return = function _return() {
    buffer = new FIFO();
    end();
    return {
      done: true
    };
  };

  var _throw = function _throw(err) {
    end(err);
    return {
      done: true
    };
  };

  pushable = (_pushable2 = {}, _defineProperty(_pushable2, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_pushable2, "next", waitNext), _defineProperty(_pushable2, "return", _return), _defineProperty(_pushable2, "throw", _throw), _defineProperty(_pushable2, "push", push), _defineProperty(_pushable2, "end", end), _pushable2);
  if (!onEnd) return pushable;
  var _pushable = pushable;
  pushable = (_pushable3 = {}, _defineProperty(_pushable3, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_pushable3, "next", function next() {
    return _pushable.next();
  }), _defineProperty(_pushable3, "throw", function _throw(err) {
    _pushable.throw(err);

    if (onEnd) {
      onEnd(err);
      onEnd = null;
    }

    return {
      done: true
    };
  }), _defineProperty(_pushable3, "return", function _return() {
    _pushable.return();

    if (onEnd) {
      onEnd();
      onEnd = null;
    }

    return {
      done: true
    };
  }), _defineProperty(_pushable3, "push", push), _defineProperty(_pushable3, "end", function end(err) {
    _pushable.end(err);

    if (onEnd) {
      onEnd(err);
      onEnd = null;
    }

    return pushable;
  }), _pushable3);
  return pushable;
};